import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "fa fa-spinner fa-spin" }

import {
  onMounted,
  useTemplateRef,
  reactive,
  computed,
} from 'vue';

interface ModalState{
  modalBodyMaxHeight: number;
}

// 汎用モーダル。呼び出し元ごとに使う項目が異なるが、全propにwithDefaultsで既定値を設定している
interface Props {
  title?: string;
  body?: string;
  showHeader?: boolean;
  showTopDismissButton?: boolean;
  topDismissButtonLabel?: string;
  topDismissButtonClass?: string;
  isCloseButtonBusy?: boolean;
  isCloseButtonDisabled?: boolean;
  showFooter?: boolean;
  showBottomCloseButton?: boolean;
  bottomCloseButtonLabel?: string;
  bottomCloseButtonClass?: string;
  showBottomCloseButtonIcon?: boolean;
  bottomCloseButtonIconClass?: string;
  showBottomDismissButton?: boolean;
  bottomDismissButtonLabel?: string;
  flipBottomButton?: boolean;
  maxWidthStr?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    title: { default: '' },
    body: { default: '' },
    showHeader: { type: Boolean, default: true },
    showTopDismissButton: { type: Boolean, default: false },
    topDismissButtonLabel: { default: 'x' },
    topDismissButtonClass: { default: 'close' },
    isCloseButtonBusy: { type: Boolean, default: false },
    isCloseButtonDisabled: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: true },
    showBottomCloseButton: { type: Boolean, default: true },
    bottomCloseButtonLabel: { default: 'OK' },
    bottomCloseButtonClass: { default: 'btn-primary' },
    showBottomCloseButtonIcon: { type: Boolean, default: false },
    bottomCloseButtonIconClass: { default: 'fa-trash' },
    showBottomDismissButton: { type: Boolean, default: true },
    bottomDismissButtonLabel: { default: 'キャンセル' },
    flipBottomButton: { type: Boolean, default: false },
    maxWidthStr: {}
  },
  emits: ["dismiss", "close"],
  setup(__props: any) {

const props = __props;



const refModalDialog = useTemplateRef<HTMLElement>('refModalDialog');
const refModalHeader = useTemplateRef<HTMLElement>('refModalHeader');
const refModalFooter = useTemplateRef<HTMLElement>('refModalFooter');
const state = reactive<ModalState>({
  modalBodyMaxHeight: 350,
});
onMounted(() => {
  const windowH = window.innerHeight;
  const dialogOffsetTop = refModalDialog.value?.offsetTop || 0;
  const modalHeaderH = refModalHeader.value?.clientHeight || 0;
  const modalFooterH = refModalFooter.value?.clientHeight || 0;
  state.modalBodyMaxHeight = windowH - modalHeaderH - modalFooterH - dialogOffsetTop * 2;
});

const shouldCloseButtonDisabled = computed(() => {
  return props.isCloseButtonBusy || props.isCloseButtonDisabled;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "modal-dialog",
            ref_key: "refModalDialog",
            ref: refModalDialog,
            style: _normalizeStyle({'max-width': __props.maxWidthStr})
          }, [
            _createElementVNode("div", _hoisted_3, [
              (__props.showHeader)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-header",
                    ref_key: "refModalHeader",
                    ref: refModalHeader
                  }, [
                    (__props.showTopDismissButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(__props.topDismissButtonClass),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss')))
                        }, _toDisplayString(__props.topDismissButtonLabel), 3))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "header", {}, () => [
                      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1)
                    ])
                  ], 512))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "modal-body",
                style: _normalizeStyle({'max-height': state.modalBodyMaxHeight+'px'})
              }, [
                _renderSlot(_ctx.$slots, "body", {
                  modalBodyMaxHeight: state.modalBodyMaxHeight
                }, () => [
                  _createTextVNode(_toDisplayString(__props.body), 1)
                ])
              ], 4),
              (__props.showFooter)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "modal-footer",
                    ref_key: "refModalFooter",
                    ref: refModalFooter
                  }, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      (__props.flipBottomButton)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (__props.showBottomDismissButton)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-secondary",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dismiss')))
                                }, _toDisplayString(__props.bottomDismissButtonLabel), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (__props.showBottomCloseButton)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass(["btn", __props.bottomCloseButtonClass]),
                            disabled: shouldCloseButtonDisabled.value,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                          }, [
                            _withDirectives(_createElementVNode("i", _hoisted_6, null, 512), [
                              [_vShow, __props.isCloseButtonBusy]
                            ]),
                            (__props.showBottomCloseButtonIcon)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(["fa", __props.bottomCloseButtonIconClass])
                                }, null, 2)), [
                                  [_vShow, !__props.isCloseButtonBusy]
                                ])
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("span", null, _toDisplayString(__props.bottomCloseButtonLabel), 513), [
                              [_vShow, !__props.isCloseButtonBusy]
                            ])
                          ], 10, _hoisted_5))
                        : _createCommentVNode("", true),
                      (!__props.flipBottomButton)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (__props.showBottomDismissButton)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-secondary",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('dismiss')))
                                }, _toDisplayString(__props.bottomDismissButtonLabel), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ], 512))
                : _createCommentVNode("", true)
            ])
          ], 4)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-backdrop" }, null, -1))
      ])
    ]),
    _: 3
  }))
}
}

})